var _rule = require("../rule.js");

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _rule2.default.makeRule({
    name: "math-text-empty",
    severity: _rule2.default.Severity.WARNING,
    selector: "math, blockMath",
    pattern: /\\text{\s*}/,
    message: "Empty \\text{} block in math expression"
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/gorgon/rules/math-text-empty.js
 ** module id = 230
 ** module chunks = 0 2
 **/